import * as actionTypes from "../../constants/actionTypes";
import { getBrand, getBrandIds, getBrands } from "../../api/brand";
import { OFFER_TYPES } from "../../constants/offerTypes";

const invalidateBrands = () => {
  return {
    type: actionTypes.INVALIDATE_BRANDS_DATA
  };
};

const loadBrand = (clientConfig, brandId) => {
  return {
    type: actionTypes.LOAD_BRAND_DATA,
    promise: getBrand(clientConfig, brandId)
  };
};

const loadBrandPhoneOfferIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_BRAND_PHONE_OFFER_IDS_DATA,
    promise: getBrandIds(clientConfig, OFFER_TYPES.phoneOffer, dataStatus)
  };
};

const loadBrandPropositionIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_BRAND_PROPOSITION_IDS_DATA,
    promise: getBrandIds(clientConfig, OFFER_TYPES.proposition, dataStatus)
  };
};

const loadBrands = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_BRANDS_DATA,
    promise: getBrands(clientConfig, dataStatus)
  };
};

export {
  invalidateBrands,
  loadBrand,
  loadBrandPhoneOfferIds,
  loadBrandPropositionIds,
  loadBrands
};
